import { IsString, MaxLength } from 'class-validator';

export class ProductSearchDTO {

    @IsString()
    @MaxLength(50)
    name: string;

}
